export const rangeHeight = 17;

export const todayHeight = 24;

export const todayWidth = 35;

export const todayBorderRadius = 4;
